'use strict';

export default function HeadlineService($http, MixpanelService) {
  var vm = this;
  vm.analysis = null;

  vm.analyze = function analyze(headline) {
    MixpanelService.track('Headline Analyzed');

    $http
      .post('/headlines/analyze', {
        headline: headline
      })
      .then(function(response) {
        vm.analysis = response.data;
      });
  };

  vm.reset = function reset() {
    vm.analysis = null;
  };

  return vm;
}

HeadlineService.$inject = ['$http', 'MixpanelService'];
